import React from "react";
import { styled } from "../../stitches.config";


import dots from "../../assets/img/natemat/kropki-flaga.svg"


const SpecialDaysCounter = props => {
    const { article } = props;

    return (
        <Wrapper>
            <a href={article.link}><img src={dots} /><span>{article.title_normal}</span></a>
        </Wrapper>

    );
}

const Wrapper = styled("div", {
    padding: "18px 0",
    "@media (min-width: 992px)": {
        padding: "10px 30px"
    },
    "a": {
        color: "#272424",
        display: "flex",
        alignItems: "flex-start"
    },
    "img": {
        width: "6px",
        marginRight: "8px",
        marginTop: "2px"
    }
});

export default SpecialDaysCounter